// src/json/servicesOverview.json
export const servicesOverviewBalconyRenewal = {
    eyebrow: "OUR BALCONY RENEWAL",
    titleHighlight: "SERVICES INCLUDE:",
    items: [
        {
            title: "Concrete Repair & Resurfacing",
            description: "Fixing cracks, spalling, and surface deterioration to restore strength and stability."
        },
        {
            title: "Waterproofing & Membrane Installation",
            description: "Applying high-performance waterproofing systems to prevent leaks, moisture damage, and corrosion."
        },
        {
            title: "Railing Replacement & Refinishing",
            description: "Upgrading or restoring metal, glass, or aluminum railings to enhance safety and aesthetics."
        },
        {
            title: "Sealant & Expansion Joint Replacement",
            description: "Installing new caulking and expansion joints to prevent water intrusion and structural movement damage."
        },
        {
            title: "Protective Coatings & Finishes",
            description: "Applying non-slip, weather-resistant coatings for long-term protection and improved visual appeal."
        }
    ],
    imageUrl: "/assets/imgs/services/9BalconyRenewal/servicesOverview/fondo.jpg",
    button: {
        text: "Request a Quote",
        url: "/quote"
    }
};  